import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const Main = styled.section`
  padding: 110px 0;
  position: relative;
  z-index: 10;
  background:
    radial-gradient(circle at 85% 5%, ${(props) => props.theme.text}10 0%, transparent 42%),
    #f6f7f9;

  @media screen and (max-width: 768px) {
    padding: 80px 0;
  }
`;

export const MaxWidth = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    padding: 0 22px;
  }
`;

export const Title = styled(motion.h2)`
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(props) => props.theme.text};
  margin-bottom: 10px;
`;

export const Heading = styled(motion.h1)`
  text-align: center;
  font-size: 42px;
  font-weight: 700;
  color: #0f1115;
  margin-bottom: 36px;
  font-family: 'Poppins', sans-serif;

  @media screen and (max-width: 768px) {
    font-size: 30px;
  }
`;

export const Filters = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-bottom: 48px;
`;

export const FilterBtn = styled.button`
  padding: 9px 18px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid ${({ $active, theme }) => ($active ? theme.text : '#d8dbe0')};
  background: ${({ $active, theme }) => ($active ? theme.text : '#ffffff')};
  color: ${({ $active }) => ($active ? '#fff' : '#424a57')};

  &:hover {
    border-color: ${(props) => props.theme.text};
    color: ${({ $active, theme }) => ($active ? '#fff' : theme.text)};
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 26px;

  @media screen and (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled(motion(Link))`
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e6e8ec;
  text-decoration: none;
  box-shadow: 0 14px 36px -26px rgba(15, 17, 21, 0.55);
  transition: transform 0.28s ease, box-shadow 0.28s ease, border-color 0.28s ease;

  &:hover {
    transform: translateY(-7px);
    border-color: ${(props) => props.theme.text};
    box-shadow: 0 26px 60px -28px ${(props) => props.theme.text};
  }
`;

export const Thumb = styled.div`
  position: relative;
  height: 200px;
  overflow: hidden;
  background: #0f1115;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  ${Card}:hover & img {
    transform: scale(1.06);
  }
`;

export const Tag = styled.span`
  position: absolute;
  top: 14px;
  left: 14px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  color: #fff;
  background: ${(props) => props.theme.text};
  backdrop-filter: blur(4px);
`;

export const Body = styled.div`
  padding: 22px 24px 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CardTop = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
`;

export const CardTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #0f1115;
`;

export const Year = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #9aa3b2;
`;

export const Desc = styled.p`
  font-size: 14.5px;
  line-height: 1.6;
  color: #6b7280;
  margin-bottom: 18px;
  flex: 1;
`;

export const TechRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 16px;
`;

export const TechChip = styled.span`
  font-size: 12px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 8px;
  color: #424a57;
  background: #f1f3f6;
  border: 1px solid #e6e8ec;
`;

export const ViewMore = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => props.theme.text};

  svg {
    transition: transform 0.2s ease;
  }
  ${Card}:hover & svg {
    transform: translateX(4px);
  }
`;
